import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCFaqDetailComponent = class UiCFaqDetailComponent {
    constructor() { }
    formatDate(date) {
        const day = date.getDate().toString(), dayF = (day.length == 1) ? '0' + day : day, month = this.month((date.getMonth() + 1)), year = date.getFullYear();
        return dayF + '-' + month + '-' + year;
    }
    month(month) {
        let monthString;
        switch (month) {
            case 1:
                monthString = 'Jan';
                break;
            case 2:
                monthString = 'Fev';
                break;
            case 3:
                monthString = 'Mar';
                break;
            case 4:
                monthString = 'Abr';
                break;
            case 5:
                monthString = 'Mai';
                break;
            case 6:
                monthString = 'Jun';
                break;
            case 7:
                monthString = 'Jul';
                break;
            case 8:
                monthString = 'Ago';
                break;
            case 9:
                monthString = 'Set';
                break;
            case 10:
                monthString = 'Out';
                break;
            case 11:
                monthString = 'Nov';
                break;
            case 12:
                monthString = 'Dez';
                break;
            default: monthString = '--';
        }
        return monthString;
    }
};
__decorate([
    Input()
], UiCFaqDetailComponent.prototype, "faqDetail", void 0);
UiCFaqDetailComponent = __decorate([
    Component({
        selector: 'ui-c-faq-detail',
        template: "<div class=\"faq-detail-component p-0\">\n  <div class=\"faq-selected ion-padding-vertical\">\n    <ion-text class=\"faq-title\">\n      <h5 class=\"font-family-bold font-size-15 ion-padding-horizontal ion-no-margin\">\n        {{faqDetail.title}}\n      </h5>\n    </ion-text>\n    <ion-text>\n      <p class=\"ion-text font-size-14 ion-no-margin ion-margin-top ion-padding-horizontal\">\n        {{faqDetail.subtitle}}\n      </p>\n      <p class=\"ion-text font-size-14 ion-no-margin ion-margin-top ion-padding-horizontal\">\n        {{formatDate(faqDetail.date)}}\n      </p>\n    </ion-text>\n    <ion-text>\n      <h5 class=\"font-family-bold ion-text font-size-14 ion-no-margin ion-margin-top ion-padding-horizontal\">\n        {{faqDetail.description}}\n      </h5>\n      <p class=\"ion-text font-size-14 ion-no-margin ion-margin-top ion-padding-horizontal\">\n        {{faqDetail.fullDescription}}\n      </p>\n    </ion-text>\n  </div>\n</div>\n",
        styles: [""]
    })
], UiCFaqDetailComponent);

let UiCFaqDetailModule = class UiCFaqDetailModule {
};
UiCFaqDetailModule = __decorate([
    NgModule({
        declarations: [UiCFaqDetailComponent],
        imports: [
            CommonModule,
            IonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCFaqDetailComponent]
    })
], UiCFaqDetailModule);

/*
 * Public API Surface of ui-c-faq-detail
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCFaqDetailComponent, UiCFaqDetailModule };
//# sourceMappingURL=wlp-ui-c-faq-detail.js.map
